<!--
 * @Descripttion: 
 * @Author: luoyang
 * @Date: 2021-12-01 13:20:20
 * @LastEditors: luoyang
 * @LastEditTime: 2021-12-01 13:54:18
-->
<template>
  <!-- 目标用户 -->
  <div class="target_user-mb">
    <div class="title ml71">
      目标用户
    </div>
    <p class="target_user_info-mb ml71">致力于解决企业级车务管理</p>
    <ul ref="ul" class="target_user_info-ul mobile-container">
      <li v-for="(item,i) in targetuser" :key="i" :ref="'li'+i" class="targetuser_bg-mb" :style="{background: 'url('+item.bg+')' }">
        <div class="targetuser_title-mb"><span>{{item.title}}</span></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    targetuser: {
      type: Array,
      default: [],
    },
  },
};
</script>
<style lang="scss" scoped>
.target_user-mb {
  background: #f9f9f9;
  padding-bottom: 213px; //284-71
  .padding-bottom-213 {
    padding-bottom: 213px;
  }
  .title {
    width: 1720px;
    height: 180px;
    line-height: 180px;
    font-size: 156px;
    font-weight: 600;
    padding: 284px 0 174px;
    box-sizing: content-box;
    color: #000000;
  }
  .target_user_info-mb {
    font-size: 71px;
    color: #323333;
    margin-bottom: 178px;
  }
  .target_user_info-ul {
    display: flex;
    flex-wrap: wrap;
    .targetuser_bg-mb {
      background-size: cover !important;
      width: 853px;
      height: 1525px;
      position: relative;
      margin-bottom: 71px;
      .targetuser_title-mb {
        height: 306px;
        position: absolute;
        bottom: 0px;
        padding: 109px 0 69px 108px;
        font-size: 71px;
        color: #ffffff;
        width: 100%;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
      }
      /* 第1、3、5个子元素 */
      &:nth-child(2n + 1) {
        margin-right: 71px;
      }
    }
  }
}
</style>